module.exports = __webpack_public_path__ + "img/instrument-traffic.8fe4f39a.png";